[
  {
    "code": "4-4-2",
    "version": 1,
    "slots": [
      {
        "slot": 1,
        "assignedPosition": "GOALKEEPER",
        "label": "POR",
        "x": 0.5,
        "y": 0.9
      },
      {
        "slot": 2,
        "assignedPosition": "DEFENDER",
        "label": "LI",
        "x": 0.2,
        "y": 0.73
      },
      {
        "slot": 3,
        "assignedPosition": "DEFENDER",
        "label": "DFC",
        "x": 0.4,
        "y": 0.73
      },
      {
        "slot": 4,
        "assignedPosition": "DEFENDER",
        "label": "DFC",
        "x": 0.6,
        "y": 0.73
      },
      {
        "slot": 5,
        "assignedPosition": "DEFENDER",
        "label": "LD",
        "x": 0.8,
        "y": 0.73
      },
      {
        "slot": 6,
        "assignedPosition": "MIDFIELDER",
        "label": "MI",
        "x": 0.2,
        "y": 0.45
      },
      {
        "slot": 7,
        "assignedPosition": "MIDFIELDER",
        "label": "MC",
        "x": 0.4,
        "y": 0.45
      },
      {
        "slot": 8,
        "assignedPosition": "MIDFIELDER",
        "label": "MC",
        "x": 0.6,
        "y": 0.45
      },
      {
        "slot": 9,
        "assignedPosition": "MIDFIELDER",
        "label": "MD",
        "x": 0.8,
        "y": 0.45
      },
      {
        "slot": 10,
        "assignedPosition": "FORWARD",
        "label": "DC",
        "x": 0.3333333333333333,
        "y": 0.17
      },
      {
        "slot": 11,
        "assignedPosition": "FORWARD",
        "label": "DC",
        "x": 0.6666666666666666,
        "y": 0.17
      }
    ]
  },
  {
    "code": "4-3-3",
    "version": 1,
    "slots": [
      {
        "slot": 1,
        "assignedPosition": "GOALKEEPER",
        "label": "POR",
        "x": 0.5,
        "y": 0.9
      },
      {
        "slot": 2,
        "assignedPosition": "DEFENDER",
        "label": "LI",
        "x": 0.2,
        "y": 0.73
      },
      {
        "slot": 3,
        "assignedPosition": "DEFENDER",
        "label": "DFC",
        "x": 0.4,
        "y": 0.73
      },
      {
        "slot": 4,
        "assignedPosition": "DEFENDER",
        "label": "DFC",
        "x": 0.6,
        "y": 0.73
      },
      {
        "slot": 5,
        "assignedPosition": "DEFENDER",
        "label": "LD",
        "x": 0.8,
        "y": 0.73
      },
      {
        "slot": 6,
        "assignedPosition": "MIDFIELDER",
        "label": "MC",
        "x": 0.25,
        "y": 0.45
      },
      {
        "slot": 7,
        "assignedPosition": "MIDFIELDER",
        "label": "MCD",
        "x": 0.5,
        "y": 0.55
      },
      {
        "slot": 8,
        "assignedPosition": "MIDFIELDER",
        "label": "MC",
        "x": 0.75,
        "y": 0.45
      },
      {
        "slot": 9,
        "assignedPosition": "FORWARD",
        "label": "EI",
        "x": 0.25,
        "y": 0.17
      },
      {
        "slot": 10,
        "assignedPosition": "FORWARD",
        "label": "DC",
        "x": 0.5,
        "y": 0.17
      },
      {
        "slot": 11,
        "assignedPosition": "FORWARD",
        "label": "ED",
        "x": 0.75,
        "y": 0.17
      }
    ]
  },
  {
    "code": "4-2-3-1",
    "version": 1,
    "slots": [
      {
        "slot": 1,
        "assignedPosition": "GOALKEEPER",
        "label": "POR",
        "x": 0.5,
        "y": 0.9
      },
      {
        "slot": 2,
        "assignedPosition": "DEFENDER",
        "label": "LI",
        "x": 0.2,
        "y": 0.73
      },
      {
        "slot": 3,
        "assignedPosition": "DEFENDER",
        "label": "DFC",
        "x": 0.4,
        "y": 0.73
      },
      {
        "slot": 4,
        "assignedPosition": "DEFENDER",
        "label": "DFC",
        "x": 0.6,
        "y": 0.73
      },
      {
        "slot": 5,
        "assignedPosition": "DEFENDER",
        "label": "LD",
        "x": 0.8,
        "y": 0.73
      },
      {
        "slot": 6,
        "assignedPosition": "MIDFIELDER",
        "label": "MCD",
        "x": 0.3333333333333333,
        "y": 0.55
      },
      {
        "slot": 7,
        "assignedPosition": "MIDFIELDER",
        "label": "MCD",
        "x": 0.6666666666666666,
        "y": 0.55
      },
      {
        "slot": 8,
        "assignedPosition": "MIDFIELDER",
        "label": "MI",
        "x": 0.25,
        "y": 0.35
      },
      {
        "slot": 9,
        "assignedPosition": "MIDFIELDER",
        "label": "MCO",
        "x": 0.5,
        "y": 0.35
      },
      {
        "slot": 10,
        "assignedPosition": "MIDFIELDER",
        "label": "MD",
        "x": 0.75,
        "y": 0.35
      },
      {
        "slot": 11,
        "assignedPosition": "FORWARD",
        "label": "DC",
        "x": 0.5,
        "y": 0.17
      }
    ]
  },
  {
    "code": "3-4-3",
    "version": 1,
    "slots": [
      {
        "slot": 1,
        "assignedPosition": "GOALKEEPER",
        "label": "POR",
        "x": 0.5,
        "y": 0.9
      },
      {
        "slot": 2,
        "assignedPosition": "DEFENDER",
        "label": "DFC",
        "x": 0.25,
        "y": 0.73
      },
      {
        "slot": 3,
        "assignedPosition": "DEFENDER",
        "label": "DFC",
        "x": 0.5,
        "y": 0.73
      },
      {
        "slot": 4,
        "assignedPosition": "DEFENDER",
        "label": "DFC",
        "x": 0.75,
        "y": 0.73
      },
      {
        "slot": 5,
        "assignedPosition": "MIDFIELDER",
        "label": "MI",
        "x": 0.2,
        "y": 0.45
      },
      {
        "slot": 6,
        "assignedPosition": "MIDFIELDER",
        "label": "MC",
        "x": 0.4,
        "y": 0.45
      },
      {
        "slot": 7,
        "assignedPosition": "MIDFIELDER",
        "label": "MC",
        "x": 0.6,
        "y": 0.45
      },
      {
        "slot": 8,
        "assignedPosition": "MIDFIELDER",
        "label": "MD",
        "x": 0.8,
        "y": 0.45
      },
      {
        "slot": 9,
        "assignedPosition": "FORWARD",
        "label": "EI",
        "x": 0.25,
        "y": 0.17
      },
      {
        "slot": 10,
        "assignedPosition": "FORWARD",
        "label": "DC",
        "x": 0.5,
        "y": 0.17
      },
      {
        "slot": 11,
        "assignedPosition": "FORWARD",
        "label": "ED",
        "x": 0.75,
        "y": 0.17
      }
    ]
  },
  {
    "code": "3-5-2",
    "version": 1,
    "slots": [
      {
        "slot": 1,
        "assignedPosition": "GOALKEEPER",
        "label": "POR",
        "x": 0.5,
        "y": 0.9
      },
      {
        "slot": 2,
        "assignedPosition": "DEFENDER",
        "label": "DFC",
        "x": 0.25,
        "y": 0.73
      },
      {
        "slot": 3,
        "assignedPosition": "DEFENDER",
        "label": "DFC",
        "x": 0.5,
        "y": 0.73
      },
      {
        "slot": 4,
        "assignedPosition": "DEFENDER",
        "label": "DFC",
        "x": 0.75,
        "y": 0.73
      },
      {
        "slot": 5,
        "assignedPosition": "MIDFIELDER",
        "label": "MI",
        "x": 0.16666666666666666,
        "y": 0.45
      },
      {
        "slot": 6,
        "assignedPosition": "MIDFIELDER",
        "label": "MC",
        "x": 0.3333333333333333,
        "y": 0.45
      },
      {
        "slot": 7,
        "assignedPosition": "MIDFIELDER",
        "label": "MCD",
        "x": 0.5,
        "y": 0.55
      },
      {
        "slot": 8,
        "assignedPosition": "MIDFIELDER",
        "label": "MC",
        "x": 0.6666666666666666,
        "y": 0.45
      },
      {
        "slot": 9,
        "assignedPosition": "MIDFIELDER",
        "label": "MD",
        "x": 0.8333333333333334,
        "y": 0.45
      },
      {
        "slot": 10,
        "assignedPosition": "FORWARD",
        "label": "DC",
        "x": 0.3333333333333333,
        "y": 0.17
      },
      {
        "slot": 11,
        "assignedPosition": "FORWARD",
        "label": "DC",
        "x": 0.6666666666666666,
        "y": 0.17
      }
    ]
  }
]
